import { clsx } from "clsx";
import { Section } from "@/components/Section/Section";
import "@/components/guide/guide-system.css";
import "./KitNavbar.css";

export interface KitNavbarProps {
  ctaLabel: string;
  ctaHref: string;
  logoHref?: string;
  id?: string;
}

/**
 * Navbar (`kit-navbar`) — sticky top nav shared by every premium landing:
 * brand logo on the left, a single purple CTA button on the right. Visual
 * vocabulary lives in `guide-system.css` (`.nav`, `.logo`, `.ds-btn`);
 * `KitNavbar.css` only pins the JSON-render wrapper sticky (see its header).
 * Extracted from `GuideNav`. JSON-composable (ADR-0076 kit convention).
 *
 * Migrated onto `<Section as="header">` (ADR-0091 phase 2 batch D) via class
 * passthrough — `padding="none"`/`background="none"` because the nav's
 * vertical rhythm is the bespoke `.nav-inner` fixed height, not the
 * `.section` scale. The row layout rides `Section`'s `containerLayout`
 * (a `Flex` container, ADR-0094); `.nav-inner` keeps only the fixed height.
 */
export function KitNavbar({ ctaLabel, ctaHref, logoHref = "/", id }: KitNavbarProps) {
  return (
    <Section
      as="header"
      id={id}
      padding="none"
      background="none"
      className="nav"
      containerClassName="wrap nav-inner"
      containerLayout={{ justify: "between", align: "center" }}
      data-component="KitNavbar"
    >
      <a href={logoHref} className="logo">
        Лена <i>про карьеру</i>
      </a>
      <a
        href={ctaHref}
        className={clsx("ds-btn", "ds-btn-purple")}
        data-track="guide-nav.cta.primary"
      >
        {ctaLabel}
      </a>
    </Section>
  );
}

KitNavbar.displayName = "KitNavbar";
